import {MeetingRepository} from "../../../api/repositories/MeetingRepository";
import {RepositoryFabric} from "../../../api/repositories/RepositoryFabric";
import {Meeting} from "../../../api/models/meetings/Meeting";
import {Participant} from "../../../api/models/meetings/Participant";
import {ParticipantStatuses} from "../../../api/enums/Meetings/ParticipantStatuses";
import Vue from 'vue';
import {Rating} from "../../../api/models/Rating";
import {RatingRepository} from "../../../api/repositories/RatingRepository";
import {WebinarInfo} from "../../../api/models/WebinarInfo";
import {UserRepository} from "@api/repositories/UserRepository";
import {CommentRepository} from "@api/repositories/CommentRepository";

export class MeetingDataHelper {
    meetingRepository: MeetingRepository;
    ratingRepository: RatingRepository;
    userRepository: UserRepository;
    commentRepository: CommentRepository;
    id: string;
    meeting: Meeting;
    userId: number;
    currentUserParticipantIndex: number;
    currentUserParticipant: Participant = new Participant({});
    likes: Rating;
    webinarInfo: WebinarInfo;
    commentsCount = 0;

    constructor(userId: number, repositories: RepositoryFabric) {
        this.meetingRepository = repositories.get(RepositoryFabric.MEETING);
        this.ratingRepository = repositories.get(RepositoryFabric.RATING);
        this.userRepository = repositories.get(RepositoryFabric.USER);
        this.commentRepository = repositories.get(RepositoryFabric.COMMENT);
        this.userId = userId;
    }

    async setMeeting(id: string) {
        this.id = id;
        await this.fetchMeeting();
        if (this.meeting && !this.meeting.isDeleted && this.meeting.isNow()) {
            await this.fetchWebinarInfo();
        }
        await this.fetchLikes();
        await this.fetchActivities();
        await this.fetchCommentsAmount();
    }

    setMeetingObject(meeting: Meeting) {
        Vue.set(this, 'meeting', meeting);
        this.identifyCurrentUserParticipant();
    }

    async fetchMeeting() {
        Vue.set(this, 'meeting', await this.meetingRepository.find(this.id));
        this.identifyCurrentUserParticipant();
    }

    identifyCurrentUserParticipant() {
        this.currentUserParticipantIndex = this.meeting.participants.findIndex(item => item.userId == this.userId);
        if (this.currentUserParticipantIndex > -1) {
            Vue.set(this, 'currentUserParticipant', this.meeting.participants[this.currentUserParticipantIndex]);
        }
    }

    async changeStatus(status: ParticipantStatuses) {
        await this.meetingRepository.changeStatus(this.currentUserParticipant.id, status);
        this.updateStatus(status);
    }

    updateStatus(status: ParticipantStatuses) {
        this.currentUserParticipant.status = status;
    }

    async fetchLikes() {
        let likes = {};
       [likes] = await this.ratingRepository.query('Meetings', [this.meeting.id as string]);
       Vue.set(this, 'likes', likes ||  {});
    }

    async fetchWebinarInfo() {
        try {
            Vue.set(this, 'webinarInfo', await this.meetingRepository.webinar(this.meeting.id as string) || {});
        }
        catch (e) {
            if (e.name === 'BackendUnexpectedError') {
                throw e;
            } else {
                Vue.set(this, 'webinarInfo', {});
            }
        }
    }

    private async fetchCommentsAmount() {
        const count = await this.commentRepository.countViaQueryMethod('Meetings', [this.id]) || 0;
        Vue.set(this, 'commentsCount', count);
    }

    /**
     * Ses status without sending a request
     * @param status
     */
    setStatus(status: ParticipantStatuses) {
        this.currentUserParticipant.status = status;
    }

    reset() {
        this.id = '';
        Vue.set(this, 'meeting', {});
        Vue.set(this, 'currentUserParticipant', {});
        Vue.set(this, 'likes', {});
    }

    updateMeeting(meeting: Meeting) {
        if (meeting.id == this.id) {
            Vue.set(this, 'meeting', meeting);
            this.identifyCurrentUserParticipant();
        }
    }

    async connect() {
        return await this.meetingRepository.webinar(this.meeting.id as string);
    }

    async toggleLike(value: number | null) {
        await this.ratingRepository.rate('Meetings', this.meeting.id as string, value);
    }

    async fetchActivities() {
        let ids = this.meeting.participants.map(item => item.userId).filter(item => item);
        ids = Array.from(new Set(ids));
        if (ids && ids.length) {
            const activities = await this.userRepository.activity(ids as number[], 'first');
            this.meeting.participants.forEach(participant => {
                participant.userId && participant.setFirstEntranceStatus(!!activities[participant.userId]);
            })
        }
    }
}